import styled from 'styled-components'
import BasicCouponCardContent from './BasicCouponCardContent'

type BasicCouponCardType = {
  title: string
  name: string
  amount: string
  datePeriod: string
  isMembership: boolean
  isConjunctUse: boolean
  couponCoverageContent: string
  isExcludeCouponCoverage: boolean
  disabled: boolean
}

const BasicCouponCard = ({
  title,
  isMembership,
  isConjunctUse,
  name,
  amount,
  datePeriod,
  couponCoverageContent,
  isExcludeCouponCoverage,
  disabled,
}: BasicCouponCardType) => {
  return (
    <Wrapper disabled={disabled}>
      <BasicCouponCardContent
        title={title}
        name={name}
        amount={amount}
        datePeriod={datePeriod}
        isMembership={isMembership}
        isConjunctUse={isConjunctUse}
        couponCoverageContent={couponCoverageContent}
        isExcludeCouponCoverage={isExcludeCouponCoverage}
        disabled={disabled}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ disabled: boolean }>`
  & * {
    ${({ disabled, theme }) => disabled && `color: ${theme.color.gray300} !important;`}
  }
  width: 100%;
  padding: 1.6rem;
  border-radius: 0.8rem;
  border: 1px solid ${({ theme }) => theme.color.gray100};
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &[disabled] {
    pointer-events: none;
    border-color: ${({ theme }) => theme.color.gray100};
  }
`

export default BasicCouponCard
